import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SpinnerService } from './spinner.service';
import { finalize } from 'rxjs/operators';

export const SPINNER_MESSAGE = new HttpContextToken<string>(() => '');
export const SPINNER_SILENT = new HttpContextToken<boolean>(() => false);

export const SpinnerInterceptor: HttpInterceptorFn = (req, next) => {
	const spinnerService = inject(SpinnerService);

	const isSilent = req.context.get(SPINNER_SILENT);
	if (isSilent) {
		return next(req);
	}

	const message = req.context.get(SPINNER_MESSAGE);

	spinnerService.show(message);

	// prettier-ignore
	return next(req).pipe(
		finalize(() => spinnerService.hide())
	);
};
